import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Modal from 'react-modal';

//style
import './App.css';

//components
import { LoginRedirect } from './helpers/LoginRedirect';
//css
import './App.css';
import { UseAccessToken } from './helpers/UseAccessToken';

Modal.setAppElement(document.getElementById('root'));

export default function App() {
  return (
    <>
      <AuthenticatedTemplate>
        <UseAccessToken />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginRedirect />
      </UnauthenticatedTemplate>
    </>
  );
}
